import { repositoryHost } from "@/repositories";
import { serviceHost } from "@/services";
import { useQuery } from "@tanstack/react-query";

const databaseService = serviceHost.getDatabaseService();
const customerMetricsRepository =
  repositoryHost.getCustomerMetricsRepository(databaseService);

export const useCustomerMetrics = (customerId: string) => {
  return useQuery({
    queryKey: ["customerMetrics", "customerId", customerId],
    queryFn: () => customerMetricsRepository.get({ id: customerId }),
    enabled: !!customerId,
  });
};
